import api from '../../../api/parametres/_fiche-consultations'

export default {
    getListeFicheConsultation(type_consultation_id) {
        return new Promise((resolve, reject) => {
            api.getListeFicheConsultation(type_consultation_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveFicheConsultation(data) {
        return new Promise((resolve, reject) => {
            api.saveFicheConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSectionByTypeConsultation(data) {
        return new Promise((resolve, reject) => {
            api.getSectionByTypeConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    geListeChampByFicheSection(data) {
        return new Promise((resolve, reject) => {
            api.geListeChampByFicheSection(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    editerNomSection(data) {
        return new Promise((resolve, reject) => {
            api.editerNomSection(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    geAllChampsByDataType(data) {
        return new Promise((resolve, reject) => {
            api.geAllChampsByDataType(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateChampListe(data) {
        return new Promise((resolve, reject) => {
            api.updateChampListe(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    checkUserAccessOnTypePrestation(data) {
        return new Promise((resolve, reject) => {
            api.checkUserAccessOnTypePrestation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveDefaultFicheConsultation(data) {
        return new Promise((resolve, reject) => {
            api.saveDefaultFicheConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeFicheConsultationSection(data) {
        return new Promise((resolve, reject) => {
            api.getListeFicheConsultationSection(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getGroupedFicheConsultation(data) {
        return new Promise((resolve, reject) => {
            api.getGroupedFicheConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    startConsultation(data) {
        return new Promise((resolve, reject) => {
            api.startConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveConsultationFicheSectionData(data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationFicheSectionData(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getCustomConsultationSectionData(data) {
        return new Promise((resolve, reject) => {
            api.getCustomConsultationSectionData(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveCustomSectionData(data) {
        return new Promise((resolve, reject) => {
            api.saveCustomSectionData(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getCustomSectionContent(data) {
        return new Promise((resolve, reject) => {
            api.getCustomSectionContent(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteFicheSectionContent(data) {
        return new Promise((resolve, reject) => {
            api.deleteFicheSectionContent(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    activateConsultationFicheChamp(data) {
        return new Promise((resolve, reject) => {
            api.activateConsultationFicheChamp(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeDiagnosticDHIS2(data) {
        return new Promise((resolve, reject) => {
            api.getListeDiagnosticDHIS2(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveConsultationPlanTraitement(data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationPlanTraitement(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}